/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-06-30 11:16:27
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-07-01 15:23:59
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Currency/Components/index.ts
 */
export { default as CurrencyModal } from './CurrencyModal';
export { default as showWarningModal } from './WarningModal';
